import { createContext, useContext } from "react";

/**
 * Shared trigger for the auth modal.
 *
 * `openAuthModal({ onSuccess })` opens the modal and registers a callback
 * that fires exactly once when the user becomes authenticated (login or
 * registration completes). If the user closes the modal without authing,
 * the callback never fires and is discarded.
 *
 * The state and modal mount live in `App.jsx`. Pages call `useAuthModal()`
 * to get the trigger function.
 */
export const AuthModalContext = createContext({
    openAuthModal: () => {
        throw new Error("AuthModalContext used outside <AuthModalProvider>");
    },
});

export function useAuthModal() {
    return useContext(AuthModalContext);
}
